import { Text } from '@/components/atoms/text';
import { ReactNode } from 'react';
import {
  Image,
  FormContent,
  FormsTitle,
  NewAccountOrAlreadyHaveAnAccount,
  Container,
  LogoContainer,
  Logo,
  StyledImageContainer,
  StyledFormContainer,
  Title,
  Subtitle,
  LanguageSelectorContainer,
} from './styles';
import { Skeleton, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { SafeMarkdown } from '@/components/atoms/markdown/safe';
import { LanguageSelector } from '@/components/molecules/languageSelector';

type AuthTemplateProps = {
  children: ReactNode;
  title: string;
  subtitle: string;
  anchorText: string;
  languageLoading?: boolean;
};

export const AuthTemplate = ({
  children,
  title,
  subtitle,
  anchorText,
  languageLoading,
}: AuthTemplateProps) => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Container>
      <StyledFormContainer>
        <FormContent>
          <FormsTitle>
            <LogoContainer>
              <Logo src="/img/png/logos/logo_kyt.png" alt="Logo" />
            </LogoContainer>

            {languageLoading ? (
              <Skeleton
                variant="text"
                width={100}
                height={32}
                sx={{ transform: 'none', marginBottom: theme.spacing(0.5) }}
                animation="wave"
              />
            ) : (
              <Title variant={isMobile ? 'h5' : 'h4'} primary>
                {title}
              </Title>
            )}

            {languageLoading ? (
              <Skeleton
                variant="text"
                width={250}
                height={32}
                sx={{ transform: 'none' }}
                animation="wave"
              />
            ) : (
              <Subtitle variant="subtitle1" secondary>
                {subtitle}
              </Subtitle>
            )}
          </FormsTitle>

          {children}

          <NewAccountOrAlreadyHaveAnAccount>
            {languageLoading ? (
              <Skeleton
                variant="text"
                width={250}
                height={20}
                sx={{ transform: 'none' }}
                animation="wave"
              />
            ) : (
              <Text variant="body2" textAlign="center">
                <SafeMarkdown text={anchorText} target="_self" />
              </Text>
            )}
          </NewAccountOrAlreadyHaveAnAccount>

          <LanguageSelectorContainer>
            <LanguageSelector />
          </LanguageSelectorContainer>
        </FormContent>
      </StyledFormContainer>

      <StyledImageContainer>
        <Image src="/img/png/logos/arte-home-Kyt.png" alt="arte-home-Kyt" />
      </StyledImageContainer>
    </Container>
  );
};
